export const AllCampaignsId = -1;
export const AllCampaignsObject = { id: AllCampaignsId };

export default AllCampaignsObject;
